import React from 'react';
import {
  FormControl, InputLabel, MenuItem, Select,
} from '@mui/material';
import { useTranslation } from '../../common/components/LocalizationProvider';
import useReportStyles from '../common/useReportStyles';

const ColumnSelect = ({
  columns, setColumns, columnsArray, columnsObject,
}) => {
  const classes = useReportStyles();
  const t = useTranslation();

  return (
    <div className={classes.filterItem}>
      <FormControl fullWidth>
        <InputLabel>{t('sharedColumns')}</InputLabel>
        <Select
          label={t('sharedColumns')}
          value={columns}
          onChange={(e) => setColumns(e.target.value)}
          multiple
        >
          {columnsArray
            ? columnsArray.map(([key, string]) => (
              <MenuItem key={key} value={key}>{t(string)}</MenuItem>
            ))
            : Object.keys(columnsObject).map((key) => (
                  ["io11", "io12", "io13", "io14", "io15", "io16", "io17", "io18", "io21", "io22", "io23", "io24", "io25", "io26", "tempCalculated", "fixTime", "serverTime", "deviceTime"].includes(key) === true ?
                      <MenuItem key={key} value={key}>{columnsObject[key].name}</MenuItem>
                      : null
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default ColumnSelect;
